import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PrivateRoute } from '../components';
import Theme from './settings/Theme';

const propTypes = {
  bootComplete: PropTypes.bool.isRequired,
  features: PropTypes.shape({
    theme: PropTypes.bool,
  }).isRequired,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

function SettingsCarrierRouter({ bootComplete, features, match }) {
  return (
    <React.Fragment>
      {bootComplete && features.theme && <PrivateRoute exact path={`${match.path}/theme`} component={Theme} />}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    bootComplete: state.bootComplete,
    features: state.features,
  };
}
SettingsCarrierRouter.propTypes = propTypes;
export default connect(mapStateToProps)(SettingsCarrierRouter);
